// John Eldhose 20180511
import React, { Component } from 'react';
import  { Redirect } from 'react-router-dom';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Grid, Tooltip, Typography } from '@material-ui/core';
import { AccountBox, ExitToApp } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { isAuthenticated } from '../Api/isAuthenticated';
import { logout } from '../Api/logout';
import { loadLoginPage } from './lib/LoginPage';

class Home extends Component {

  state = {
    loaded: false,
    isAuth: 0,
    AcademyDemo: 0,
    dialog: ''
  }
  componentWillMount() {
    isAuthenticated()
      .then((auth) => {
        if(auth.status === 'true') {
          this.setState({
            isAuth: auth.auth, AcademyDemo: auth.academyDemo, loaded: true
          });
          const LoginPage = loadLoginPage();
          if(auth.auth === 7)
            this.props.history.push('/profile');
          else if(LoginPage !== null) {
            window.location = LoginPage.url;
            return <div />;
          }
        }
        else
          this.setState({ loaded: true });
      })
      .catch(() => {
        this.setState({ loaded: true });
      })
  }
  handleClickProfile = () => {
    this.props.history.push('/profile');
  }
  handleClickLogout = () => {
    logout()
      .then((status) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      })
    window.open('https://photocapture.carlsonsw.com/logout_for_cp.php', '_blank', 'width=200,height=100');
  }
  handleClickManageAccount = () => {
    if(this.state.isAuth > 0 && (this.state.isAuth % 5) === 0)
      this.props.history.push('/manageaccount');
    else
      this.setState({ dialog: 'Your account is not associated with your corporate account. Please contact your corporate administrator or your Carlson sales support or technical support to gain access.' });
  }
  handleClickPhotoCapture = () => {
    window.open('/photocapture', '_blank');
  }
  handleClickAcademy = () => {
    if((this.state.isAuth % 3) === 0)
      window.open('/academy', '_blank');
    else if((this.state.isAuth % 2) === 0) {
      if(this.state.AcademyDemo > 0)
        window.open('/academy', '_blank');
      else
        this.setState( { dialog: 'Maintenance in your account has expired. Please renew maintenance to gain access.' });
    }
    else
      this.setState({ dialog: 'Your account is not associated with your corporate account. Please contact administrator for your corporate account or your Carlson sales support or technical support to gain access.' });
  }
  handleClickDemoProducts = () => {
    this.props.history.push('/demo');
  }
  handleClickProductDownloads = () => {
    this.props.history.push('/downloads');
  }

  render() {
    if(!this.state.loaded) {
      return(
        <div style={{ height: '100%' }}>
          <div style={{ height: '170px' }}>&nbsp;</div>
          <CircularProgress size={50} style={{ color: '#00A8E4' }} />
        </div>
      );
    }
    else if(this.state.isAuth > 0) {
      return (
        <div>
          <Typography variant='display1'>
            <font color='#385687'>Carlson Account Portal</font>
          </Typography>
          <Grid container>
            <Grid item xs={12} sm={12} md={6} className='HomeItem'>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickProfile}
              >
                <AccountBox />
                <FormattedMessage
                  id='Profile'
                  defaultMessage='Profile'
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className='HomeItem'>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickLogout}
              >
                <ExitToApp />
                <FormattedMessage
                  id='Logout'
                  defaultMessage='Logout'
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className='HomeItem'>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickManageAccount}
              >
                <div>
                  <Typography variant="title">
                    <FormattedMessage
                      id='Manage Account'
                      defaultMessage='Manage Account'
                    />
                  </Typography>
                  <img src='myproduct.png' alt='My Products' />
                </div>
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className='HomeItem'>
              <Tooltip
                title={
                  <Typography style={{ color: 'white' }}>
                    Photogrammetry software to bridge the gap between drones and CAD
                  </Typography>
                }
                placement='top'
              >
                <Button
                  fullWidth
                  variant="outlined"
                  style={{ textTransform: 'none' }}
                  onClick={this.handleClickPhotoCapture}
                >
                  <div>
                    <Typography variant="title">
                      <FormattedMessage
                        id='PhotoCapture'
                        defaultMessage='PhotoCapture'
                      />
                    </Typography>
                    <img src='photo-capture-icon.png' alt='PhotoCapture' />
                  </div>
                </Button>
              </Tooltip>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className='HomeItem'>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickAcademy}
              >
                <div>
                  <Typography variant="title">
                    <FormattedMessage
                      id='Academy'
                      defaultMessage='Academy'
                    />
                  </Typography>
                  <img src='academy-icon.png' alt='Academy' />
                </div>
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className='HomeItem'>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickDemoProducts}
              >
                <div>
                  <Typography variant="title">
                    <FormattedMessage
                      id='Demo Products'
                      defaultMessage='Demo Products'
                    />
                  </Typography>
                  <img src='demo.png' alt='Demo Products' />
                </div>
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className='HomeItem'>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickProductDownloads}
              >
                <div>
                  <Typography variant="title">
                    <FormattedMessage
                      id='SurvCE/PC 6.0 Legacy Downloads'
                      defaultMessage='SurvCE/PC 6.0 Legacy Downloads'
                    />
                  </Typography>
                  <img src='SurvCE6.png' alt='My Downloads' />
                </div>
              </Button>
            </Grid>
            <Dialog open={this.state.dialog !== ''}>
              <DialogContent>
                <Typography variant="subheading">
                  {this.state.dialog}
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => this.setState({ dialog: '' })}
                  color="primary"
                  autoFocus
                >
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </div>
      );
    }
    else {
      return (<Redirect to='/login'  />);
    }
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js